import {
  IconAnalytics,
  IconBinocularsGray,
  IconChartBar,
  IconClockGray,
  IconCoil,
  IconLayers,
  IconLocation,
  IconMeter,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconShareGray,
  IconWarning,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/logisticsAsset/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/logisticsAsset/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/logisticsAsset/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/logisticsAsset/video/sub/rtlsVideo3.mp4';
import subVideo4 from '@src/assets/images/solution/logisticsAsset/video/sub/rtlsVideo4.mp4';

import image1 from '@src/assets/images/solution/logisticsAsset/img/1.avif';
import image2 from '@src/assets/images/solution/logisticsAsset/img/2.avif';
import image3 from '@src/assets/images/solution/logisticsAsset/img/3.avif';
import image4 from '@src/assets/images/solution/logisticsAsset/img/4.avif';

export default {
  type: '물류 솔루션',
  banner: {
    title: '창고 자산의 이동을 자동 기록하고, 입출고를 실시간으로 통제하세요',
    desc: '자산의 입출고 시점과 이동 경로를 자동 추적하여 물류 흐름을 디지털화하고, 수작업 없이도 정확한 재고 파악과 이상 상황 감지를 가능하게 합니다.',
  },

  video: {
    title: '정확한 위치 데이터로 물류 창고 운영의 효율을 높이세요.',
    desc: '복잡한 물류 창고에서도 개별 자산의 위치를 실시간으로 추적하여 자산 관리의 정확성과 효율성을 극대화합니다.',
    play: video,
  },

  func: [
    {
      theme: '물류 자산의 위치를 정확히 추적하고 관리하세요.',
      title: '자산 위치의 실시간 모니터링',
      desc: '대규모 물류 창고 내에서도 개별 자산의 위치를 ±50cm 이내로 정확히 파악하여, 실시간으로 자산 현황과 분포를 확인할 수 있습니다. 빠르고 정확한 재고 관리가 가능합니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '빠른 데이터 연동',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: '초소형 스티커 태그로 자산 관리 간소화',
      desc: '초소형 스티커 태그를 자산에 부착하여 관리의 편의성을 높이고, 어떤 크기나 형태의 자산이라도 쉽게 위치 추적 시스템을 적용할 수 있습니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '높은 정확도 제공',
      icon2: IconRulerGray,
      image: image2,
    },
    {
      title: '대규모 자산 관리에 특화된 시스템',
      desc: '1만 개 이상의 재고 자산도 동시에 실시간으로 모니터링하고 관리할 수 있어, 대규모 물류 환경에서 높은 효율성을 보장합니다.',
      sub1: '빠른 데이터 연동',
      icon1: IconShareGray,
      sub2: '실시간 현황 파악',
      icon2: IconClockGray,
      image: image3,
    },
    {
      title: '자산 위치 검색 및 즉시 파악',
      desc: '강력한 검색 기능을 통해 필요 자산의 위치를 손쉽게 즉시 확인할 수 있어 재고 관리의 시간과 노력을 최소화합니다.',
      sub1: '빠른 데이터 연동',
      icon1: IconShareGray,
      sub2: '실시간 현황 파악',
      icon2: IconClockGray,
      video: subVideo3,
    },
    {
      theme: '자산 데이터를 통해 운영 효율성을 높이고 위험 요소를 예방하세요.',
      title: '실시간 입출고 현황 파악',
      desc: '반출과 입고 등 모든 물류 현황을 실시간으로 모니터링하여, 물류 이동을 정확히 추적하고 운영 오류를 사전에 방지합니다.',
      sub1: '빠른 데이터 연동',
      icon1: IconShareGray,
      sub2: '실시간 현황 파악',
      icon2: IconClockGray,
      video: subVideo4,
    },
    {
      title: '창고별 적정 재고량 모니터링',
      desc: '창고마다 재고 자산의 적정량을 실시간으로 분석하여 공간 활용을 최적화하고, 창고 공간 부족 문제를 사전에 해결할 수 있습니다.',
      sub1: '빠른 데이터 연동',
      icon1: IconShareGray,
      sub2: '실시간 현황 파악',
      icon2: IconClockGray,
      image: image4,
    },
    {
      title: '무단 반출 및 자산 유실 방지 알림',
      desc: '자산의 무단 반출이 발생하거나 지정된 시간대를 벗어날 경우 즉시 알림을 전송하여, 자산 유실 위험을 사전에 차단합니다.',
      sub1: '빠른 데이터 연동',
      icon1: IconShareGray,
      sub2: '실시간 현황 파악',
      icon2: IconClockGray,
      video: subVideo1,
    },
    {
      title: '재고 상태 실시간 모니터링',
      desc: '구역별 및 전체 재고 현황을 실시간으로 직관적으로 확인할 수 있어, 정확한 재고 운영과 신속한 의사 결정을 지원합니다.',
      sub1: '빠른 데이터 연동',
      icon1: IconShareGray,
      sub2: '실시간 현황 파악',
      icon2: IconClockGray,
      video: subVideo2,
    },
  ],

  subfunc: {
    title: '주요기능 요약',
    desc: '',

    data: [
      {
        icon: IconLocation, // 실시간 자산 위치 확인 → Location (위치 직접 표현)
        title: '실시간 자산 위치 확인',
        desc: '물류 창고 내 모든 자산의 위치를 실시간으로 정확히 확인합니다.',
      },
      {
        icon: IconCoil, // 초소형 스티커 태그 제공 → Tag: 태그 상징 (없으면 ChainLink 유지)
        title: '초소형 스티커 태그 제공',
        desc: '작은 크기의 태그로 다양한 자산에 쉽게 부착해 위치 추적합니다.',
      },
      {
        icon: IconLayers, // 대규모 자산 동시 관리 → Layers: 다층 구조, 대규모 의미
        title: '대규모 자산 동시 관리',
        desc: '1만 개 이상의 자산도 동시에 실시간 관리할 수 있습니다.',
      },
      {
        icon: IconSearch, // 자산 위치 검색 기능 → Search 유지
        title: '자산 위치 검색 기능',
        desc: '필요한 자산의 위치를 간편한 검색 기능으로 신속히 확인합니다.',
      },
      {
        icon: IconRoute, // 실시간 입출고 현황 파악 → Route 유지
        title: '실시간 입출고 현황 파악',
        desc: '입고와 출고 현황을 실시간으로 정확히 모니터링합니다.',
      },
      {
        icon: IconChartBar, // 창고별 적정 재고량 분석 → ChartBar: 분석/리포트
        title: '창고별 적정 재고량 분석',
        desc: '창고별 재고량과 공간 여유를 분석하여 효율적인 공간 운영을 지원합니다.',
      },
      {
        icon: IconWarning, // 무단 반출 자동 알림 → Warning: 경고 의미
        title: '무단 반출 자동 알림',
        desc: '자산이 지정된 시간대를 벗어나거나 무단 반출될 경우 즉각 알림을 전송합니다.',
      },
      {
        icon: IconMeter, // 재고 상태 실시간 확인 → Meter: 상태계 의미
        title: '재고 상태 실시간 확인',
        desc: '전체 창고 및 구역별 재고 현황을 직관적으로 실시간 파악합니다.',
      },
      {
        icon: IconRoute, // 자산 이동 경로 기록 → Route 유지
        title: '자산 이동 경로 기록',
        desc: '자산의 이동 경로를 자동으로 기록하고 데이터로 저장합니다.',
      },
      {
        icon: IconAnalytics, // 자산 데이터 기반 리포트 → Analytics: 데이터 리포트 강조
        title: '자산 데이터 기반 리포트',
        desc: '자동으로 자산 이동 데이터를 분석하여 관리 보고서를 주기적으로 제공합니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'logisticsSafety',
    },
    {
      data: 'constructionAsset',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogForklift',
    },
  ],
};
